module.exports = __webpack_public_path__ + "img/UTSAND-3.1bbf7929.jpg";